// import React, { useState, useEffect } from "react";
// import { BiArrowBack } from "react-icons/bi";
// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";

// const EditCompetitiveNotes = () => {
//   const [noteTitle, setNoteTitle] = useState("");
//   const [file, setFile] = useState(null); // Capture the actual file object
//   const [language, setLanguage] = useState("");
//   const [examCategories, setExamCategories] = useState([]);
//   const [examCategoryId, setExamCategoryId] = useState("");
//   const [competitiveSubjects, setCompetitiveSubjects] = useState([]);
//   const [competitiveSubjectId, setCompetitiveSubjectId] = useState("");

//   const { id } = useParams(); // Assuming you pass the note ID in the URL
//   const navigate = useNavigate();
//   const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

//   // Fetch data when the component mounts
//   useEffect(() => {
//     // Fetch the note data by ID
//     axios
//       .get(`${API_BASE_URL}/notes/${id}`)
//       .then((response) => {
//         const { noteTitle, language, examCategoryId, competitiveSubjectId } =
//           response.data?.data;
//         setNoteTitle(noteTitle);
//         setLanguage(language);
//         setExamCategoryId(examCategoryId);
//         setCompetitiveSubjectId(competitiveSubjectId);
//       })
//       .catch((error) => console.log(error));

//     // Fetch exam categories
//     axios
//       .get(`${API_BASE_URL}/competitions`)
//       .then((response) => setExamCategories(response.data?.data || []))
//       .catch((error) => console.log(error));
//   }, [id, API_BASE_URL]);

//   // Fetch subjects based on the selected exam category
//   useEffect(() => {
//     if (examCategoryId) {
//       axios
//         .get(`${API_BASE_URL}/subjects?reference=${examCategoryId}`)
//         .then((response) => setCompetitiveSubjects(response.data?.data || []))
//         .catch((error) => console.log(error));
//     }
//   }, [examCategoryId, API_BASE_URL]);

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const formData = new FormData();
//     formData.append("noteTitle", noteTitle);
//     formData.append("language", language);
//     if (file) formData.append("noteFile", file);

//     axios
//       .put(`${API_BASE_URL}/admin/notes/${id}`, formData, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       })
//       .then(() => {
//         alert("Note updated successfully!");
//         navigate("/upload-notes/upload-all-competitive-notes");
//       })
//       .catch((error) => console.log(error));
//   };

//   const handleAddNewNote = () =>
//     navigate("/upload-notes/upload-add-competitive-notes");
//   const handleViewAllNotes = () =>
//     navigate("/upload-notes/upload-all-competitive-notes");
//   const handleGoBack = () => navigate("/upload-notes/upload-all-notes");

//   return (
//     <div id="exam-competitive-notes-inner-wrapper">
//       <div className="competitive-main-header">
//         <BiArrowBack
//           onClick={handleGoBack}
//           className="left-arrow-icon"
//           style={{ cursor: "pointer", fontSize: "25px", color: "#000" }}
//         />
//         <div className="competitive-header-div">
//           <h5>Edit Competitive Notes</h5>
//           <div className="competitive-btn-group">
//             <button
//               className="addNewCompetitiveNoteBtn"
//               onClick={handleAddNewNote}
//             >
//               + Upload Notes
//             </button>
//             <button
//               className="viewAllCompetitiveNotesBtn"
//               onClick={handleViewAllNotes}
//             >
//               All Notes
//             </button>
//           </div>
//         </div>

//         <div className="competitive-form-container" id="form">
//           <h4 className="competitive-note-detail">Edit Files</h4>
//           <form
//             onSubmit={handleSubmit}
//             className="competitive-note-detail-form"
//           >
//             {/* <div className="new-chapter-form-group">
//               <label className="new-chapter-label">Exam Category</label>
//               <select
//                 className="new-chapter-dropdown"
//                 value={examCategoryId}
//                 onChange={(e) => setExamCategoryId(e.target.value)}
//                 required
//               >
//                 <option value="">-Select Category-</option>
//                 {examCategories.map((examCategory, idx) => (
//                   <option key={idx} value={examCategory._id}>
//                     {examCategory.examCategory}
//                   </option>
//                 ))}
//               </select>
//             </div> */}

//             {/* <div className="new-chapter-form-group">
//               <label className="new-chapter-label">Subject Name</label>
//               <select
//                 className="new-chapter-dropdown"
//                 value={competitiveSubjectId}
//                 onChange={(e) => setCompetitiveSubjectId(e.target.value)}
//                 required
//               >
//                 <option value="">-Select Subject-</option>
//                 {competitiveSubjects.map((competitiveSubject, idx) => (
//                   <option key={idx} value={competitiveSubject._id}>
//                     {competitiveSubject.subjectName}
//                   </option>
//                 ))}
//               </select>
//             </div> */}

//             <div className="input-group">
//               <label className="label">Note Title</label>
//               <input
//                 type="text"
//                 value={noteTitle}
//                 onChange={(e) => setNoteTitle(e.target.value)}
//                 placeholder="Enter Note Title"
//                 required
//               />
//             </div>

//             <div className="input-group">
//               <label className="label">Language</label>
//               <input
//                 type="radio"
//                 value="hindi"
//                 checked={language === "hindi"}
//                 onChange={(e) => setLanguage(e.target.value)}
//                 required
//               />{" "}
//               Hindi
//               <input
//                 type="radio"
//                 value="english"
//                 checked={language === "english"}
//                 onChange={(e) => setLanguage(e.target.value)}
//                 required
//               />{" "}
//               English
//             </div>

//             <div className="input-group">
//               <label className="label">Upload File (pdf format)</label>
//               <input
//                 type="file"
//                 onChange={(e) => setFile(e.target.files[0])}
//                 accept=".pdf"
//               />
//             </div>

//             <div className="competitive-form-btns">
//               <button className="competitive-btn-save" type="submit">
//                 Save
//               </button>
//               <button
//                 className="competitive-btn-cancel"
//                 type="button"
//                 onClick={handleGoBack}
//               >
//                 Cancel
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EditCompetitiveNotes;





import React, { useState, useEffect } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const EditCompetitiveNotes = () => {
  const [noteTitle, setNoteTitle] = useState("");
  const [file, setFile] = useState(null); // Capture the actual file object
  const [language, setLanguage] = useState("");
  const [examCategories, setExamCategories] = useState([]);
  const [examCategoryId, setExamCategoryId] = useState("");
  const [competitiveSubjects, setCompetitiveSubjects] = useState([]);
  const [competitiveSubjectId, setCompetitiveSubjectId] = useState("");

  // ✅ ADDED: videoUrl state
  const [videoUrl, setVideoUrl] = useState("");

  const { id } = useParams(); // Assuming you pass the note ID in the URL
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;

  // Fetch data when the component mounts
  useEffect(() => {
    // Fetch the note data by ID
    axios
      .get(`${API_BASE_URL}/notes/${id}`)
      .then((response) => {
        const data = response.data?.data || {};

        // keep existing fields (do not remove anything)
        setNoteTitle(data.noteTitle || "");
        setLanguage(data.language || "");

        // these may or may not exist depending on your schema
        setExamCategoryId(data.examCategoryId || "");
        setCompetitiveSubjectId(data.competitiveSubjectId || "");

        // ✅ ADDED: set existing videoUrl
        setVideoUrl(data.videoUrl || "");
      })
      .catch((error) => console.log(error));

    // Fetch exam categories
    axios
      .get(`${API_BASE_URL}/competitions`)
      .then((response) => setExamCategories(response.data?.data || []))
      .catch((error) => console.log(error));
  }, [id, API_BASE_URL]);

  // Fetch subjects based on the selected exam category
  useEffect(() => {
    if (examCategoryId) {
      axios
        .get(`${API_BASE_URL}/subjects?reference=${examCategoryId}`)
        .then((response) => setCompetitiveSubjects(response.data?.data || []))
        .catch((error) => console.log(error));
    }
  }, [examCategoryId, API_BASE_URL]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("noteTitle", noteTitle);
    formData.append("language", language);

    // ✅ ADDED: include videoUrl in update
    formData.append("videoUrl", videoUrl);

    if (file) formData.append("noteFile", file);

    const role = localStorage.getItem("role");
    const endpoint =
      role === "subAdmin"
        ? `${API_BASE_URL}/subadmin/notes/${id}`
        : `${API_BASE_URL}/admin/notes/${id}`;


    axios
      .put(endpoint, formData, {
        headers: {
          // keep existing header pattern
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(() => {
        alert("Note updated successfully!");
        navigate("/upload-notes/upload-all-competitive-notes");
      })
      .catch((error) => console.log(error));
  };

  const handleAddNewNote = () =>
    navigate("/upload-notes/upload-add-competitive-notes");
  const handleViewAllNotes = () =>
    navigate("/upload-notes/upload-all-competitive-notes");
  const handleGoBack = () => navigate("/upload-notes/upload-all-notes");

  return (
    <div id="exam-competitive-notes-inner-wrapper">
      <div className="competitive-main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{ cursor: "pointer", fontSize: "25px", color: "#000" }}
        />
        <div className="competitive-header-div">
          <h5>Edit Competitive Notes</h5>
          <div className="competitive-btn-group">
            <button
              className="addNewCompetitiveNoteBtn"
              onClick={handleAddNewNote}
            >
              + Upload Notes
            </button>
            <button
              className="viewAllCompetitiveNotesBtn"
              onClick={handleViewAllNotes}
            >
              All Notes
            </button>
          </div>
        </div>

        <div className="competitive-form-container" id="form">
          <h4 className="competitive-note-detail">Edit Files</h4>
          <form
            onSubmit={handleSubmit}
            className="competitive-note-detail-form"
          >
            {/* <div className="new-chapter-form-group">
              <label className="new-chapter-label">Exam Category</label>
              <select
                className="new-chapter-dropdown"
                value={examCategoryId}
                onChange={(e) => setExamCategoryId(e.target.value)}
                required
              >
                <option value="">-Select Category-</option>
                {examCategories.map((examCategory, idx) => (
                  <option key={idx} value={examCategory._id}>
                    {examCategory.examCategory}
                  </option>
                ))}
              </select>
            </div> */}

            {/* <div className="new-chapter-form-group">
              <label className="new-chapter-label">Subject Name</label>
              <select
                className="new-chapter-dropdown"
                value={competitiveSubjectId}
                onChange={(e) => setCompetitiveSubjectId(e.target.value)}
                required
              >
                <option value="">-Select Subject-</option>
                {competitiveSubjects.map((competitiveSubject, idx) => (
                  <option key={idx} value={competitiveSubject._id}>
                    {competitiveSubject.subjectName}
                  </option>
                ))}
              </select>
            </div> */}

            <div className="input-group">
              <label className="label">Note Title</label>
              <input
                type="text"
                value={noteTitle}
                onChange={(e) => setNoteTitle(e.target.value)}
                placeholder="Enter Note Title"
                required
              />
            </div>

            {/* ✅ ADDED: Video URL input */}
            <div className="input-group">
              <label className="label">Video URL</label>
              <input
                type="text"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
                placeholder="https://youtube.com/watch?v=..."
              />
              {!!videoUrl && (
                <small style={{ display: "block", marginTop: 6 }}>
                  <a href={videoUrl} target="_blank" rel="noreferrer">
                    Preview Video
                  </a>
                </small>
              )}
            </div>

            <div className="input-group">
              <label className="label">Language</label>
              <input
                type="radio"
                value="hindi"
                checked={language === "hindi"}
                onChange={(e) => setLanguage(e.target.value)}
                required
              />{" "}
              Hindi
              <input
                type="radio"
                value="english"
                checked={language === "english"}
                onChange={(e) => setLanguage(e.target.value)}
                required
              />{" "}
              English
            </div>

            <div className="input-group">
              <label className="label">Upload File (pdf format)</label>
              <input
                type="file"
                onChange={(e) => setFile(e.target.files[0])}
                accept=".pdf"
              />
            </div>

            <div className="competitive-form-btns">
              <button className="competitive-btn-save" type="submit">
                Save
              </button>
              <button
                className="competitive-btn-cancel"
                type="button"
                onClick={handleGoBack}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCompetitiveNotes;